import React from 'react';
import { Stack } from '../Stack/Stack';

/**
 * The `<Sections>` and `<Section>` components standardize the appearance and
 * spacing of "sections" on a page.
 */
export var Sections = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: 5,
    ref: ref
  }, children);
});